export const generateTailwindColor = (input: string) => {
  const colors = [
    "bg-red-500",
    "bg-orange-500",
    "bg-yellow-500",
    "bg-green-500",
    "bg-blue-500",
    "bg-indigo-500",
    "bg-purple-500",
    "bg-pink-500",
    "bg-teal-500",
    "bg-cyan-500",
  ]

  const index = simpleHash(input) % colors.length
  return colors[index]
}

export const generateHslColor = (input: string) => {
  const colors = [
    "hsl(17, 88%, 40%)",
    "hsl(293, 69%, 49%)",
    "hsl(86, 79%, 36%)",
    "hsl(221, 83%, 53%)",
    "hsl(0, 72%, 51%)",
    "hsl(175, 77%, 26%)",
    "hsl(333, 68%, 35%)",
    "hsl(262, 83%, 58%)",
    "hsl(142, 72%, 23%)",
    "hsl(35, 92%, 33%)",
  ]

  const index = simpleHash(input) % colors.length
  return colors[index]
}

const simpleHash = (input: string) => {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export default generateTailwindColor
